import { Backdrop, Button, InputAdornment, TextField } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { listRetailerMasterStart } from "../../redux/retail-master/listRetailerMaster";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { useSearchParams } from "react-router-dom";
import { IRetailerMaster } from "./IRetailerMaster";
import RetailerMasterList from "./RetailerMasterList";
import { clearCreateRetailerMaster } from "../../redux/retail-master/createRetailerMaster";
import { clearEditRetailerMaster } from "../../redux/retail-master/editRetailerMaster";
import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";

const statusItems = [
  {
    className: "approve_sts",
    label: true,
  },
  { className: "reject_sts", label: false },
];

const RetailerMaster: FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [retailer, setRetailer] = useState<IRetailerMaster>({});
  const [search, setSearch] = useState<string>("");
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();
  const [open, setOpen] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { data: retailerList, isLoading: listRetailerLoading } = useAppSelector(
    (state) => state.ListRetailerMaster
  );
  const { isLoading: createReatilerLoading, data: createRetailer } =
    useAppSelector((state) => state.CreateRetailerMaster);

  const { isLoading: editRetailerLoading, data: editRetailer } = useAppSelector(
    (state) => state.EditRetailerMaster
  );
  const ListRetailer =
    retailerList?.result?.map((retailer, index) => ({
      ...retailer,
      index: index + 1,
    })) ?? [];

  // list render
  useEffect(() => {
    dispatch(listRetailerMasterStart(null));
  }, [createRetailer, editRetailer]);

  //clear create edit data and get the state list
  useEffect(() => {
    dispatch(raise_api_call_list_general_setting(""));
    return () => {
      dispatch(clearCreateRetailerMaster());
      dispatch(clearEditRetailerMaster());
    };
  }, []);

  useEffect(() => {
    if (ListRetailer?.length !== 0) {
      const retailerCheckById =
        searchParams.get("id") &&
        ListRetailer?.find(
          (retail) => retail.id === Number(searchParams.get("id"))
        );

      if (retailerCheckById) {
        setRetailer(retailerCheckById);
      } else {
        setRetailer({});
      }
    }
  }, [
    searchParams.get("id"),
    ListRetailer?.length,
    createRetailer,
    editRetailer,
  ]);

  const statusClassName = (value: boolean) => {
    return statusItems.find((it) => value === it.label)?.className;
  };

  const handleBack = () => {
    setRetailer({});
    setShowBack(false);
    setTitleContext("Retailer Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (retailer?.name) {
      setShowBack(true);
    }
  }, [retailer]);

  useEffect(() => {
    setTitleContext(retailer.name ?? "Retailer Master");
  }, [retailer]);

  return (
    <div className="partner-details">
      <div className={`content_container`}>
        <div
          className={`mini_side_container`}
          style={{
            display: isMobile && retailer.id ? "none" : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Retailer Master
          </h5>

          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                dispatch(listRetailerMasterStart(null));
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "arrows-rotate"]}
              />
            </Button>

            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "add"]}
              />
            </Button>
          </div>

          <div className="side_content_container">
            {ListRetailer &&
              ListRetailer.filter((item) => {
                return Object.values(item)
                  .join("")
                  .toLowerCase()
                  .includes(search.toLowerCase());
              }).map((val, key) => (
                <div
                  key={key + 1}
                  className={`side_content_card`}
                  onClick={() => {
                    val.id && setSearchParams({ id: val.id?.toString() });
                  }}
                >
                  <div
                    className={`side_content_mini_card ${
                      retailer.id === val.id ? "active" : ""
                    }`}
                  >
                    <div className="f4 title">{val.name}</div>
                    <div className="side_content_footer">
                      <h4 className="f4 subtitle">{val.address1}</h4>
                      <h4
                        className={`f5 side_status ${statusClassName(
                          val.active!
                        )}`}
                        style={{ height: "fit-content" }}
                      >
                        {val.active ? "Active" : "InActive"}
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div
          className={`mini_content_container`}
          style={{
            display: isMobile && !retailer.id ? "none" : "initial",
          }}
        >
          {Object.keys(retailer).length === 0 && (
            <div className="not_found_container">
              <img src={DataNotFound} alt="" />
              Please Select Any One Retailer
            </div>
          )}
          <RetailerMasterList
            retailer={retailer}
            open={open}
            setOpen={setOpen}
          />
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!!listRetailerLoading}
      >
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
    </div>
  );
};

export default RetailerMaster;
